import CheckPlace24hModal from './CheckPlace24hModal';

export default CheckPlace24hModal;
